import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#B1282E' },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontSize: 14, // keep base small
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true, size: 'small' },
    },
    MuiTextField: {
      defaultProps: { size: 'small' },
    },
    MuiSelect: {
      defaultProps: { size: 'small' },
    },
    MuiMenuItem: {
      defaultProps: { dense: true },
    },
    MuiToolbar: {
      defaultProps: { variant: 'dense' }, // compact header
    },
  },
});

export default theme;
